<template>
    <div class="bg-white">
        <Hero :title="$t('contact.endpage_title')" :lead="$t('generic.contact_us')" />

        <div class="container pb-32">
            <div class="grid grid-cols-2 text-black gap-y-8 lg:gap-y-0 mb-20 lg:mb-32">
                <div class="col-span-2 lg:col-span-1 lg:pr-32 flex flex-col justify-between2">
                    <div>
                        <h2 class="title title-lg decor-underline decor-underline--magenta mb-8 max-w-2xl">
                            {{ $t('navigation.companies') }}
                        </h2>
                        <h3 class="leading-7 mb-5">
                            {{ $t('contact.companies.description_long') }}
                        </h3>
                        <div class="flex flex-col font-bold mb-6">
                            <a class="mb-2" href="mailto:info@banyaiconsulting.hu">info@banyaiconsulting.hu</a>
                            <a href="tel:+36 1 950 6081">+36 1 950 6081</a>
                        </div>
                    </div>
                    <Button
                        :label="$t('contact.send_a_message')"
                        class="p-button-primary w-fit"
                        @click="openContactModal"
                    />
                </div>
                <div v-if="!$getIsLangKoZhDe()" class="col-span-2 lg:col-span-1 lg:pr-32 flex flex-col justify-between">
                    <div>
                        <h2 class="title title-lg decor-underline decor-underline--magenta mb-8 max-w-2xl">
                            {{ $t('navigation.job_seekers') }}
                        </h2>
                        <h3 class="leading-7 mb-5">
                            {{ $t('contact.job_seekers.description') }}
                        </h3>
                        <div class="flex flex-col font-bold mb-6">
                            <a class="mb-2" href="mailto:palyazat@banyaiconsulting.hu">palyazat@banyaiconsulting.hu</a>
                            <a href="tel:+36 1 950 6081">+36 1 950 6081</a>
                        </div>
                    </div>
                    <Button
                        :label="$t('contact.send_a_message')"
                        class="p-button-primary w-fit"
                        @click="openJobApplicationModal"
                    />
                </div>
            </div>
            <div class="grid grid-cols-2 rounded-bl-40 rounded-tr-40 min-h-36 bg-gray-100 overflow-hidden">
                <div class="col-span-2 lg:col-span-1">
                    <a
                        class="h-full"
                        href="https://www.google.com/maps?q=Budapest,+Logodi+utca+44/b.+1.+em.+4.&um=1&ie=UTF-8&sa=X&ved=2ahUKEwjkz82Ou5b3AhVLg_0HHX3uCKIQ_AUoAXoECAEQAw"
                        target="_blank"
                    >
                        <img
                            :src="require('~/assets/images/placeholders/map_placeholder.jpg')"
                            alt="Map"
                            class="w-full h-full object-cover cursor-pointer"
                        />
                    </a>
                </div>
                <div class="col-span-2 lg:col-span-1 p-8 lg:py-16 lg:px-24">
                    <ContactDetail
                        blue
                        text-black
                        :icon="require('~/assets/images/icons/location.svg')"
                        :label="$t('generic.company_name')"
                        class="mb-12 lg:mb-16"
                    >
                        <a
                            href="https://www.google.com/maps?q=Budapest,+Logodi+utca+44/b.+1.+em.+4.&um=1&ie=UTF-8&sa=X&ved=2ahUKEwjkz82Ou5b3AhVLg_0HHX3uCKIQ_AUoAXoECAEQAw"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="desktop:hover:underline my-2 sm:my-0 underline sm:no-underline"
                        >
                            Budapest, Logodi utca 44/b. 1. em. 4.
                        </a>
                    </ContactDetail>

                    <ContactDetail
                        blue
                        text-black
                        :icon="require('~/assets/images/icons/mail.svg')"
                        :label="$t('contact.email') + ':'"
                        class="mb-12 lg:mb-16"
                    >
                        <a
                            class="underline sm:no-underline desktop:hover:underline break-all"
                            href="mailto:info@banyaiconsulting.hu?subject=Info"
                        >
                            info@banyaiconsulting.hu
                        </a>
                        <br />
                        <a
                            v-if="!$getIsLangKoZhDe()"
                            class="underline sm:no-underline desktop:hover:underline break-all"
                            href="mailto:palyazat@banyaiconsulting.hu?subject=Pályázat"
                        >
                            palyazat@banyaiconsulting.hu
                        </a>
                    </ContactDetail>

                    <ContactDetail
                        blue
                        text-black
                        :icon="require('~/assets/images/icons/phone.svg')"
                        :label="$t('contact.phone') + ':'"
                    >
                        <a class="underline sm:no-underline desktop:hover:underline" href="tel:+3619506081">
                            +36 1 950 60 81
                        </a>
                    </ContactDetail>
                </div>
            </div>
        </div>
        <BaseModal :close="closeContactModal" :is-open="isContactModalOpen">
            <ContactForm is-modal />
        </BaseModal>
        <BaseModal :close="closeJobApplicationModal" :is-open="isJobApplicationModalOpen">
            <JobApplicationForm is-modal />
        </BaseModal>
    </div>
</template>

<script>
import Hero from '@/components/Heroes/Hero';
import ContactDetail from '@/components/Generic/ContactDetail.vue';
import BaseModal from '@/components/Modals/BaseModal.vue';
import ContactForm from '@/components/Forms/ContactForm';
import JobApplicationForm from '@/components/Forms/jobApplicationForm.vue';
export default {
    name: 'Contact',
    components: {
        Hero,
        ContactDetail,
        BaseModal,
        ContactForm,
        JobApplicationForm,
    },
    data() {
        return {
            isContactModalOpen: false,
            isJobApplicationModalOpen: false,
        };
    },
    head() {
        return {
            title: this.$getOgTitle(this.$t('contact.title')),
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.$getOgTitle(this.$t('contact.title')),
                },
                {
                    hid: 'title',
                    name: 'title',
                    content: this.$getOgTitle(this.$t('contact.title')),
                },
            ],
        };
    },
    methods: {
        openContactModal() {
            this.isContactModalOpen = !this.isContactModalOpen;
        },
        closeContactModal() {
            this.isContactModalOpen = false;
        },
        openJobApplicationModal() {
            console.log('yes');
            this.isJobApplicationModalOpen = !this.isJobApplicationModalOpen;
        },
        closeJobApplicationModal() {
            this.isJobApplicationModalOpen = false;
        },
    },
};
</script>

<style scoped>
.w-fit {
    width: fit-content;
}
</style>
